module.exports = __webpack_public_path__ + "static/delegation-dial.50831e61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delegation-dial.png
// module id = 466
// module chunks = 207076274901000